import $ from "jquery";
import gsap from "gsap-3";
import * as PIXI from "pixi.js";

var distortionSlider = function(t, e) {
  var s = {
      btnPrev: e.btnPrev || null,
      btnNext: e.btnNext || null,
      onInit: e.onInit || null,
      onSlideChange: e.onSlideChange || null,
      onForceSlideChange: e.onForceSlideChange || null,
    },
    l = {
      currentSlide: 0,
      totalSlides: 0,
      isLinked: t.is("a"),
      isSwiping: !1,
    },
    i = t.find("img"),
    c = [],
    d = [],
    a = !1,
    n = void 0,
    // o = new PIXI.loaders.Loader(),
    o = new PIXI.Loader(),
    p = void 0,
    r = [];
  function v(e, i) {
    var a = l.currentSlide;
    gsap
      .timeline({
        onStart: function() {
          (l.isSwiping = !0),
          (l.currentSlide = e),
          s.onSlideChange && !i && s.onSlideChange(l.currentSlide),
          s.onForceSlideChange && i && s.onForceSlideChange(l.currentSlide);
        },
        onComplete: function() {
          (l.isSwiping = !1), l.isLinked && t.attr("href", c[e]);
        },
      })
      .to(d[a].filter.scale, 1.3, {
        x: 1e3 + 200 * Math.random(),
        y: 1e3 + 200 * Math.random(),
      })
      .to(
        d[l.currentSlide].container,
        1,
        {
          alpha: 0,
        },
        0
      )
      .to(
        d[e].container,
        1,
        {
          alpha: 1,
        },
        0
      )
      .to(
        d[e].filter.scale,
        1.3,
        {
          x: 1,
          y: 1,
        },
        0
      );
  }
  function u() {
    (a = !1), clearInterval(n);
  }
  function h(e, i) {
    e < 0 && (e = l.totalSlides - 1),
    e >= l.totalSlides && (e = 0),
    i && u(),
    v(e);
  }
  function x(e) {
    var i = l.currentSlide - 1;
    l.isSwiping || t.hasClass("is-animating") || h(i, e);
  }
  function m(e) {
    var i = l.currentSlide + 1;
    l.isSwiping || t.hasClass("is-animating") || h(i, e);
  }
  return (
    i.each(function(e, i) {
      c.push($(i).data("link"));
    }),
    i.each(function(e, i) {
      r.push($(i).attr("src"));
    }),
    new Promise(function(a) {
      i.each(function(e, i) {
        var a = $(i).attr("src");
        o.add("image" + e, a);
      }),
      o.load(function(e, i) {
        e.destroy(), a(i);
      });
    }).then(function(e) {
      var n = e.image1.data.naturalWidth,
        o = e.image1.data.naturalHeight,
        // r = PIXI.Sprite.fromImage(
        //   require("@/assets/img/displacement-filter.png")
        // );
        r = PIXI.Sprite.from(require("@/assets/img/displacement-filter.png"));
      (p = new PIXI.Application({
        width: n,
        height: o,
        transparent: !0,
      })),
      (r.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT),
      r.scale.set(0.4 + 0.6 * Math.random()),
      $(p.view).appendTo(t),
      t.attr("href", c[0]),
      (l.totalSlides = i.length),
      i.addClass("is-hidden"),
      $.each(e, function(e, i) {
        var a = {};
        (a.container = new PIXI.Container()),
        (a.bg = PIXI.Sprite.from(i.data)),
        (a.filter = new PIXI.filters.DisplacementFilter(r));
        var t = "image0" === e ? 1 : 0,
          s = "image0" === e ? 1 : 1e3 + 200 * Math.random();
        d.push(a),
        (a.bg.width = n),
        (a.bg.height = o),
        (a.bg.position.x = 0),
        (a.bg.position.y = 0),
        (a.container.alpha = t),
        a.filter.scale.set(s),
        a.container.addChild(a.bg),
        (a.container.filters = [a.filter]),
        p.stage.addChild(a.container);
      }),
      s.btnPrev.on("click", function() {
        x(!0);
      }),
      s.btnNext.on("click", function() {
        m(!0);
      }),
      s.onInit && s.onInit();
    }),
    {
      prev: function(e) {
        x(e);
      },
      next: function(e) {
        m(e);
      },
      slideTo: function(e) {
        h(e);
      },
      forceTo: function(e) {
        !(function(e) {
          v(e, !0);
        })(e);
      },
      showSlide: function(e, i) {
        !(function(e, i) {
          gsap
            .timeline({
              onStart: function() {
                (l.isSwiping = !0), (l.currentSlide = e);
              },
              onComplete: function() {
                (l.isSwiping = !1),
                l.isLinked && t.attr("href", c[e]),
                i && i();
              },
            })
            .to(
              d[e].container,
              1,
              {
                alpha: 1,
              },
              0
            )
            .to(
              d[e].filter.scale,
              1.3,
              {
                x: 1,
                y: 1,
              },
              0
            );
        })(e, i);
      },
      hideSlide: function(e) {
        !(function(e) {
          var i = l.currentSlide;
          gsap
            .timeline({
              onStart: function() {
                l.isSwiping = !0;
              },
              onComplete: function() {
                e && e();
              },
            })
            .to(d[i].filter.scale, 1.3, {
              x: 1e3 + 200 * Math.random(),
              y: 1e3 + 200 * Math.random(),
            })
            .to(
              d[l.currentSlide].container,
              1,
              {
                alpha: 0,
              },
              0
            );
        })(e);
      },
      getState: function() {
        return l;
      },
      start: function() {
        p.start();
      },
      startAutoplay: function() {
        !0 !== a &&
          ((a = !0),
          (n = setInterval(function() {
            m();
          }, 5000)));
      },
      pause: function() {
        u();
      },
      stop: function() {
        p.stop();
      },
    }
  );
};

export default distortionSlider;
